import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcYcoin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.281 8.921q.503.207.845.605.216.251.341.561c.09.22.287.389.524.389h.419c.309 0 .547-.28.45-.573a3.3 3.3 0 0 0-.545-1.026 3.4 3.4 0 0 0-1.346-1.026 4.5 4.5 0 0 0-1.8-.351q-1.204 0-2.149.544a3.8 3.8 0 0 0-1.482 1.565Q8 10.628 8 11.999q0 1.375.535 2.394.534 1.02 1.479 1.563t2.155.544q1.005 0 1.823-.372.816-.37 1.339-1.04a3.3 3.3 0 0 0 .522-.956c.102-.292-.134-.573-.444-.574l-.423-.002c-.235-.001-.432.164-.524.38a2 2 0 0 1-.342.548q-.343.39-.845.593a3 3 0 0 1-1.099.207 2.74 2.74 0 0 1-1.435-.39q-.627-.383-.99-1.118-.362-.735-.362-1.777 0-1.033.362-1.773.362-.741.993-1.125.63-.384 1.439-.385.595 0 1.098.205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  }));
}
var IcYcoin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcYcoin));

export { IcYcoin as I };
